<script setup lang="ts">
import { computed } from 'vue'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

const props = withDefaults(
  defineProps<{
    label: string
    count: number
    variant: 'success' | 'danger' | 'warning' | 'info' | 'neutral'
    loading?: boolean
  }>(),
  {
    loading: false,
  },
)

const emit = defineEmits<{
  'click': [payload: { label: string }]
}>()

const variantClasses = computed(() => {
  const map: Record<typeof props.variant, string> = {
    success: 'text-green-600 dark:text-green-400',
    danger: 'text-red-600 dark:text-red-400',
    warning: 'text-yellow-600 dark:text-yellow-400',
    info: 'text-blue-600 dark:text-blue-400',
    neutral: 'text-gray-600 dark:text-gray-400',
  }
  return map[props.variant]
})
</script>

<template>
  <Card class="cursor-pointer hover:shadow-md transition-shadow" @click="emit('click', { label: props.label })">
    <CardHeader class="pb-2">
      <CardTitle class="text-sm font-medium text-muted-foreground">
        {{ label }}
      </CardTitle>
    </CardHeader>
    <CardContent>
      <Skeleton v-if="loading" class="h-8 w-20" />
      <div v-else :class="['text-2xl font-bold', variantClasses]">
        {{ count.toLocaleString() }}
      </div>
    </CardContent>
  </Card>
</template>
